const EMAIL_SUBDOMAIN_REGEXP = /^.+@.+\..+$/;

export default angular
	.module('ui.cian.email-subdomain-validator', [])
	.directive('cianUiEmailSubdomainValidator', () => ({
		restrict: 'A',
		require: 'ngModel',
		link: (scope, element, attrs, ngModel) => {
			const originalAngularEmailValidator = ngModel.$validators.email;
			// Расширяем функциональность email валидатора
			ngModel.$validators.email = (modelValue, viewValue) => {
				const value = modelValue || viewValue;
				return ngModel.$isEmpty(value) || (originalAngularEmailValidator(modelValue, viewValue) && EMAIL_SUBDOMAIN_REGEXP.test(value));
			};
		}
	}))
	.name;
